import { Box } from '@mui/material'

/**
 * How many events in this league cleared the threshold. It sits at the right edge rather than after the
 * label: glued to the text it read as part of the league name.
 */
function CountBadge({ count }) {
  return (
    <Box
      component="span"
      sx={{
        marginLeft: '10px',
        fontSize: '13px',
        fontVariantNumeric: 'tabular-nums',
        color: 'rgba(255, 255, 255, 0.55)'
      }}
    >
      {count}
    </Box>
  )
}

export default CountBadge
